import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalPageService } from './global-page.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    GlobalPageService
  ]
})
export class GlobalPageModule { }
